
import { message, Select, Space } from 'antd';
import styles from './index.module.scss'
import {RESOURCE_TYPE, IMAGE_TYPE} from '@utils/CONST'
import { useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../../../hooks/ProjectContext';
import API from '@api/api'

const SelectionFilter = (props) => {
    const {
        resourceFilter, setResourceFilter
    } = useContext(ProjectContext)
    const {resourceType} = props
    const [clothesCateOpts, setClothesCateOpts] = useState([])
    const [shoesTypeOpts, setShoesTypeOpts] = useState([]);
    const [shoesposeOpts, setShoesPoseOpts] = useState([]);
    const [commodityTypeCategory, setCommodityTypeCategory] = useState([]) // 商品类别
    const [sceneTypeCategory, setSceneTypeCategory] = useState([]) // 场景类别

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.TRYON_MODEL) return
        API.categoryList({
            category: 'clothesCate',
            resourceType: 'tryon',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = res.data.map(item => ({ label: item.display, value: item.value }))
            setClothesCateOpts(list || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.TRYON_SHOES) return
        Promise.all([
            API.categoryList({
                category: 'shoesType',
                resourceType: 'shoestryon',
            }),
            API.categoryList({
                category: 'poseType',
                resourceType: 'shoestryon',
            })
        ]).then(resList => {
            for (let i = 0; i < resList.length; i++) {
                const res = resList[i]
                if (res.code != 0) throw new Error(res.message)
                let shoesList = res.data.map(item => ({label: item.display, value: item.value}))
                if (i == 0) {
                    setShoesTypeOpts(shoesList)
                } else if (i == 1) {
                    setShoesPoseOpts(shoesList)
                }
            }
        }).catch(err => {
            message.error(err.message)
        })
    }, [resourceType])

    useEffect(() => {
        if(resourceType != RESOURCE_TYPE.COMMODITY_SCENE) return
        Promise.all([
            API.bgCategoryList({type: IMAGE_TYPE.COMMODITY, category: 'sceneType'}),
            API.bgCategoryList({type: IMAGE_TYPE.COMMODITY, category: 'commodityType'}),
        ]).then(res => {
            const res1 = res[0]
            const res2 = res[1]
            if (res1.code != 0) throw new Error(res1.message)
            if (res2.code != 0) throw new Error(res2.message)
            setSceneTypeCategory([...res1.data.map(item => ({
                label: item.display,
                value: item.value
            }))])
            setCommodityTypeCategory([...res2.data.map(item => ({
                label: item.display,
                value: item.value
            }))])
        }).catch(err => {
            message.warning(err.message)
        })
    }, [resourceType])

    const sexOpts = [{
        value: 'female',
        label: '女',
    }, {
        value: 'male',
        label: '男',
    }]
    const ageOpts = [{
        value: 'adult',
        label: '成年',
    }, {
        value: 'children',
        label: '儿童',
    }]
    const skinOpts = [{
        label: '黄',
        value: 'yellow',
    }, {
        label: '白',
        value: 'white',
    }, {
        label: '黑',
        value: 'black',
    }]
    const modelSceneTypeOpts = [{
        label: "室内",
        value: "室内",
    }, {
        label: "户外",
        value: "户外",
    }]
    const optFactory = (opt, placeholder, mode="multiple") => {
        return {
            mode: mode,
            allowClear: true,
            showSearch: false,
            style: { width: "100px" },
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }
    const handleChange = (key, value) => {
        if (Array.isArray(value)) {
            setResourceFilter(pre => ({...pre, [key]: [...value]}))
        } else {
            setResourceFilter(pre => ({...pre, [key]: value}))
        }
    }
    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.ModelFilterSelect_tag}>{label}</span>
    }    
    const sexSelect = (
        <Select
            {...optFactory(sexOpts, '性别')}
            value={resourceFilter.sex}
            onChange={v=>handleChange('sex', v)}
            tagRender={tagRender}
        />
    )
    const skinSelect = (
        <Select
            {...optFactory(skinOpts, '肤色')}
            value={resourceFilter.skin}
            onChange={v=>handleChange('skin', v)}
            tagRender={tagRender}
        />
    )
    const ageSelect = (
        <Select
            {...optFactory(ageOpts, '年龄')}
            value={resourceFilter.age}
            onChange={v=>handleChange('age', v)}
            tagRender={tagRender}
        />
    )
    const categorySelect = (
        <Select
            {...optFactory(clothesCateOpts, '服饰品类')}
            value={resourceFilter.clothesCate}
            onChange={v=>handleChange('clothesCate', v)}
            tagRender={tagRender}
        />
    )
    const shoesType = (
        <Select
            {...optFactory(shoesTypeOpts, '品类')}
            value={resourceFilter.shoesType}
            onChange={v => handleChange('shoesType', v)}
            tagRender={tagRender}
        />
    )
    const shoesPose = (
        <Select
            {...optFactory(shoesposeOpts, '姿势')}
            value={resourceFilter.pose}
            onChange={v => handleChange('pose', v)}
            tagRender={tagRender}
        />
    )
    const commodityType = (
        <Select
            {...optFactory(commodityTypeCategory, '商品类别', null)}
            value={resourceFilter.commodityType}
            onChange={v => handleChange('commodityType', v)}
            tagRender={tagRender}
        />
    )
    const sceneType = (
        <Select
            {...optFactory(sceneTypeCategory, '场景类别', null)}
            value={resourceFilter.sceneType}
            onChange={v => handleChange('sceneType', v)}
            tagRender={tagRender}
        />
    )
    const modelSceneType = (
        <Select
            {...optFactory(modelSceneTypeOpts, '场景类别', null)}
            value={resourceFilter.sceneType}
            onChange={v => handleChange('sceneType', v)}
            tagRender={tagRender}
        />
    )

    if (resourceType == RESOURCE_TYPE.MODEL) {
        return (
            <Space size={12}>
                {sexSelect}
                {skinSelect}
                {ageSelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
        return (
            <Space size={12}>
                {sexSelect}
                {skinSelect}
                {ageSelect}
                {categorySelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
        return (
            <Space size={12}>
                {shoesType}
                {shoesPose}
                {sexSelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
        return (
            <Space size={12}>
                {sexSelect}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
        return (
            <Space size={12}>
                {commodityType}
                {sceneType}
            </Space>
        )
    } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE || resourceType == RESOURCE_TYPE.TRYON_SCENE) {
        return (
            <Space size={12}>
                {modelSceneType}
            </Space>
        )
    }
}

export default SelectionFilter
